/*globals $:false*/

import ClipboardP from './presenter/recordm.clipboard.js';
import GroupEditInstanceP from './presenter/recordm.presenter.instance.groupedit.js';
import InstanceM from './model/recordm.model.entity.instance.js';

import tmpl from './templates/instance-container.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

/**
 * args:
 * * `core`: cob.app
 * * `opts`: accepts:
 *       * `container`: an element that should contain the UI
 *       * `exit`: a callback called when the user has asked to exit the Instance creation
 *       * `afterSave`: a callback called after saving the instance
 *       * `exitLabel`: a localize key to be used on the exit (back) button
 */
var InstanceGroupEdit = function(core, opts) {

    var _$mainContainer,
        _clipboardP,
        _instanceP;

    var _urlData,
        _query,
        _ids,
        _definitionId,
        _emptyInstanceM;

    const _opts = {...opts};

    var _loadingKey = core.getLoadingKey();

    var _getEmptyInstance = function(definitionId, loadLatch) {

        core.showLoading(_loadingKey, "_getEmptyInstance");

        InstanceM.getNewInstance(core, definitionId, false,
            function(instanceM) {
                _emptyInstanceM = instanceM;

                core.publish("modules:stack-description-updated");
                loadLatch.countDown("instance:new:empty");

                core.hideLoading(_loadingKey, "_getEmptyInstance");
            }
        );
    };

    var _start = function(definitionId, query, ids, urlData) {

        //pause and init uses this function
        _definitionId = definitionId || _definitionId;
        _urlData = urlData || _urlData;
        _query = (query && query !== "") ? query : _query;
        _ids = ids || _ids;

        // Creating a latch because the code becomes more
        // simple to read. This will happen after the domain has been loaded
        // successfully.
        var loadLatch = new utils.CountdownLatch(1, function() {

            core.showLoading(_loadingKey, "_loadLatch");

            _$mainContainer = $(tmpl({
                containerClass:"js-group-edit-container"
            }));

            core.translate("recordm.instances", _$mainContainer);

            if(_opts.container){
                window.console.debug('JB', 'appending to container')
                _$mainContainer.appendTo(_opts.container);
            } else {
                _$mainContainer.appendTo('#'+core.getAppInstanceId());
            }
            _$mainContainer.removeClass("hidden");

            _clipboardP = new ClipboardP(core);
            _clipboardP.init(urlData);

            _instanceP = new GroupEditInstanceP(core, _$mainContainer, _emptyInstanceM, _clipboardP,
                {
                    cancel: function(){
                        if(typeof _opts.exit == 'function') _opts.exit();
                        else core.navigateBack();
                    },
                    afterSave: function(){
                        if(typeof _opts.afterSave == 'function') _opts.afterSave();
                        else core.navigateBack();
                    }
                },
                {
                    exitLabel: _opts.exitLabel
                }
            );
            _instanceP.init(_query, _ids);

            core.hideLoading(_loadingKey, "_loadLatch.done");
        });

        _getEmptyInstance(_definitionId, loadLatch);
    };

    var _stop = function() {
        if (_instanceP) {
            _instanceP.destroy();
            _$mainContainer.remove();
        }
    };

    const updateSelectedIds = function(query, ids){
        _query = (query && query !== "") ? query : _query;
        _ids = ids ? ids.toString() : _ids;

        _instanceP.updateAffectedIds(query, _ids)
    };

    return {
        init: _start,
        pause: _stop,
        resume: _start,
        destroy: _stop,

        getDescription: function() {
            if (_emptyInstanceM) {
                return {
                    definition: {
                        id:_emptyInstanceM.data.jsonDefinition.id,
                        name: _emptyInstanceM.data.jsonDefinition.name,
                        description: _emptyInstanceM.data.jsonDefinition.description
                    }
                }
            } else {
               return {
                   definition: {
                       id:_definitionId
                   }
               }
            }
        },

        updateSelectedIds:updateSelectedIds,
        getIds:function(){return _ids},
        getQuery:function(){return _query}
    };
};

export default InstanceGroupEdit;
